
const zh = {
    "你主动注销后，我们将停止为你提供产品/服务，根据适用法律的要求删除你的个人信息，或使其匿名化处理":"你主动注销后，我们将停止为你提供产品/服务，根据适用法律的要求删除你的个人信息，或使其匿名化处理",
    "填写并提交注销申请，工作人员会协助你完成注销。":"填写并提交注销申请，工作人员会协助你完成注销。",
    "请求错误(400)": "请求错误(400)",
    "未授权，请重新登录(401)": "未授权，请重新登录(401)",
    "登录失效": "登录失效",
    "拒绝访问(403)": "拒绝访问(403)",
    "请求出错(404)": "请求出错(404)",
    "请求超时(408)": "请求超时(408)",
    "服务器错误(500)": "服务器错误(500)",
    "服务未实现(501)": "服务未实现(501)",
    "网络错误(502)": "网络错误(502)",
    "服务不可用(503)": "服务不可用(503)",
    "网络超时(504)": "网络超时(504)",
    "HTTP版本不受支持(505)": "HTTP版本不受支持(505)",
    "服务器错误!": "服务器错误!",
    "服务器太拥挤了~请您稍后重试": "服务器太拥挤了~请您稍后重试",
    "登录失效，请重新登录": "登录失效，请重新登录",
    "刚刚": "刚刚",
    "平台发布了通知": "平台发布了通知",
    "分钟前": "分钟前",
    "关注了你": "关注了你",
    "回复您：": "回复您：",
    "查看全部关注": "查看全部关注",
    "小时前": "小时前",
    "天前": "天前",
    "个月前": "个月前",
    "年前": "年前",
    "请先设置你的密码": "请先设置你的密码",
    "要携带的参数": "要携带的参数",
    "请用指纹解锁": "请用指纹解锁",
    "验证失败": "验证失败",
    "请用FaceID解锁": "请用FaceID解锁",
    "识别成功": "识别成功",
    "首页": "首页",
    "分类": "分类",
    "购物车": "购物车",
    "我的": "我的",
    "操作成功~": "操作成功~",
    "支付失败": "支付失败",
    "上传中": "上传中",
    "上传失败，请重试": "上传失败，请重试",
    "视频上传失败，请重试": "视频上传失败，请重试",
    "图片上传失败，请重试": "图片上传失败，请重试",
    "通知权限开启提醒": "通知权限开启提醒",
    "您还没有开启通知权限，无法接受到消息通知，是否前往设置？": "您还没有开启通知权限，无法接受到消息通知，是否前往设置？",
    "直播": "直播",
    "验证码发送成功": "验证码发送成功",
    "请输入手机号": "请输入手机号",
    "请正确输入手机号": "请正确输入手机号",
    "请发送验证码": "请发送验证码",
    "后重新获取": "后重新获取",
    "提示": "提示",
    "确定要清除本地缓存？": "确定要清除本地缓存？",
    "缓存清理完成!": "缓存清理完成!",
    "取消支付": "取消支付",
    "支付失败,请稍后重试": "支付失败,请稍后重试",
    "请输入账号": "请输入账号",
    "请正确账号": "请正确账号",
    "发送中...": "发送中...",
    "您有逾期订单未还款，请先还款": "您有逾期订单未还款，请先还款",
    "确定删除该评论": "确定删除该评论",
    "可前往至“我的优惠券“中心查看": "可前往至“我的优惠券“中心查看",
    "确定删除该提货人?": "确定删除该提货人?",
    "审核被拒绝，请重新提交": "审核被拒绝，请重新提交",
    "发现新版本": "发现新版本",
    "下次再说": "下次再说",
    "马上更新": "马上更新",
    "已是最新版本": "已是最新版本",
    "已准备好新版本,是否重启体验新版?": "已准备好新版本,是否重启体验新版?",
    "重启": "重启",
    "取消下载": "取消下载",
    "下载失败": "下载失败",
    "搜索": "搜索",
    "定位\/最近访问": "定位\/最近访问",
    "全选": "全选",
    "月": "月",
    "年": "年",
    "开始": "开始",
    "结束": "结束",
    "日": "日",
    "一": "一",
    "二": "二",
    "三": "三",
    "四": "四",
    "五": "五",
    "六": "六",
    "星期日": "星期日",
    "星期一": "星期一",
    "星期二": "星期二",
    "星期三": "星期三",
    "星期四": "星期四",
    "星期五": "星期五",
    "星期六": "星期六",
    "加载中": "加载中",
    "已加载全部数据": "已加载全部数据",
    "暂无数据": "暂无数据",
    "销量": "销量",
    "万": "万",
    "加载失败": "加载失败",
    "加载中...": "加载中...",
    "温馨提示": "温馨提示",
    "请输入内容~": "请输入内容~",
    "取消": "取消",
    "确认": "确认",
    "返回": "返回",
    "请再次确认,你已了解注销风险,并要继续执行该操作": "请再次确认,你已了解注销风险,并要继续执行该操作",
    "请输入搜索关键字": "请输入搜索关键字",
    "标题": "标题",
    "请检查网络，或者前往": "请检查网络，或者前往",
    "设置": "设置",
    "点击刷新": "点击刷新",
    "哎呀，网络信号丢失": "哎呀，网络信号丢失",
    "网络链接成功": "网络链接成功",
    "无网络链接": "无网络链接",
    "分享到": "分享到",
    "微信好友": "微信好友",
    "二维码海报": "二维码海报",
    "保存到相册": "保存到相册",
    "保存图片": "保存图片",
    "朋友圈": "朋友圈",
    "QQ空间": "QQ空间",
    "QQ好友": "QQ好友",
    "新浪微博": "新浪微博",
    "复制链接": "复制链接",
    "复制成功": "复制成功",
    "分享失败": "分享失败",
    "海报生成中...": "海报生成中...",
    "获取头像信息失败": "获取头像信息失败",
    "获取商品图片信息失败": "获取商品图片信息失败",
    "推荐一个好物给你,请查收": "推荐一个好物给你,请查收",
    "获取二维码信息失败": "获取二维码信息失败",
    "保存成功": "保存成功",
    "为你推荐": "为你推荐",
    "上拉显示更多": "上拉显示更多",
    "正在加载...": "正在加载...",
    "没有更多数据了": "没有更多数据了",
    "该商品已售馨": "该商品已售馨",
    "该商品最多能购买": "该商品最多能购买",
    "件": "件",
    "商品详情": "商品详情",
    "已取消拉黑": "已取消拉黑",
    "预售价": "预售价",
    "定金": "定金",
    "已收藏": "已收藏",
    "收藏": "收藏",
    "提示": "提示",
    "确定要清除本地缓存？": "确定要清除本地缓存？",
    "缓存清理完成!": "缓存清理完成!",
    "首页": "首页",
    "注您需要重置手机号请联系客服": "注您需要重置手机号请联系客服",
    "我的": "我的",
    "电话": "电话",
    "微信号": "微信号",
    "哈法看点": "哈法看点",
    "入驻商家": "入驻商家",
    "今日折扣": "今日折扣",
    "本地生活": "本地生活",
    "二手交易": "二手交易",
    "租房": "租房",
    "二手车": "二手车",
    "招聘": "招聘",
    "宠物": "宠物",
    "最新": "最新",
    "哈哈镜头": "哈哈镜头",
    "消息": "消息",
    "今日折扣": "今日折扣",
    "本地生活": "本地生活",
    "二手交易": "二手交易",
    "二手车": "二手车",
    "全款": "全款",
    "合租": "合租",
    "整租": "整租",
    "宠物": "宠物",
    "领养": "领养",
    "招聘": "招聘",
    "最新": "最新",
    "本地": "本地",
    "国内": "国内",
    "内地": "内地",
    "发送": "发送",
    "表情": "表情",
    "为你优选": "为你优选",
    "确定要删除选择的内容吗？": "确定要删除选择的内容吗？",
    "您的浏览器不支持 video 标签。": "您的浏览器不支持 video 标签。",
    "网址": "网址",
    "标签": "标签",
    "详情": "详情",
    "关注": "关注",
    "复制": "复制",
    "评论": "评论",
    "添加好友": "添加好友",
    "发现虚假信息，请立即举报！": "发现虚假信息，请立即举报！",
    "展开更多评论": "展开更多评论",
    "展开": "展开",
    "回复": "回复",
    "条": "条",
    "咨询": "咨询",
    "哈法惠生活": "哈法惠生活",
    "此操作将永久拉黑, 是否继续?": "此操作将永久拉黑, 是否继续?",
    "折扣分享": "折扣分享",
    "发布": "发布",
    "最新": "最新",
    "重置": "重置",
    "确定": "确定",
    "面积": "面积",
    "户型": "户型",
    "房型": "房型",
    "地址": "地址",
    "基本信息": "基本信息",
    "招聘详情": "招聘详情",
    "为您推荐": "为您推荐",
    "历史搜索": "历史搜索",
    "暂无图片": "暂无图片",
    "确定删除历史记录？": "确定删除历史记录？",
    "取消": "取消",
    "请输入想要搜索的内容": "请输入想要搜索的内容",
    "暂无数据": "暂无数据",
    "粉丝": "粉丝",
    "获赞": "获赞",
    "职业：": "职业：",
    "请输入职业": "请输入职业",
    "入住时间": "入住时间",
    "年": "年",
    "已成功复制到剪贴板": "已成功复制到剪贴板",
    "该用户还没有填写签名": "该用户还没有填写签名",
    "该用户还没有填写签名…": "该用户还没有填写签名…",
    "帖子": "帖子",
    "官方发布": "官方发布",
    "￥": "￥",
    "元": "元",
    "招聘类型：": "招聘类型：",
    "发布时间：": "发布时间：",
    "举报": "举报",
    "拉黑": "拉黑",
    "已互关": "已互关",
    "你确认要把该用户移除黑名单!": "你确认要把该用户移除黑名单!",
    "上传图片只能是 JPG, PNG 格式!": "上传图片只能是 JPG, PNG 格式!",
    "由于该用户隐私设置，关注列表不可见": "由于该用户隐私设置，关注列表不可见",
    "上传头像图片大小不能超过 2MB!": "上传头像图片大小不能超过 2MB!",
    "已关注": "已关注",
    "分享到": "分享到",
    "微信好友": "微信好友",
    "朋友圈": "朋友圈",
    "注册": "注册",
    "欢迎注册": "欢迎注册",
    "推荐人：": "推荐人：",
    "请输入验证码": "请输入验证码",
    "设置密码:": "设置密码:",
    "获取验证码": "获取验证码",
    "立即注册": "立即注册",
    "已阅读并同意": "已阅读并同意",
    "《用户注册协议》": "《用户注册协议》",
    "《隐私政策》": "《隐私政策》",
    "与": "与",
    "下载": "下载",
    "iPhone下载": "iPhone下载",
    "Android下载": "Android下载",
    "请选择举报原因": "请选择举报原因",
    "请填写举报理由": "请填写举报理由",
    "只能上传jpg/png文件,最多上传6张图片": "只能上传jpg/png文件,最多上传6张图片",
    "最多输入300字（选填）": "最多输入300字（选填）",
    "请上传应用截图，最多上传6张": "请上传应用截图，最多上传6张",
    "提交": "提交",
    "提交成功": "提交成功",
    "返回首页": "返回首页",
    "公告详情": "公告详情",
    "请输入想要搜索的": "请输入想要搜索的",
    "发帖": "发帖",
    "看帖排序": "看帖排序",
    "全部回复": "全部回复",
    "留下你的精彩回复吧 ": "留下你的精彩回复吧 ",
    "条回复": "条回复",
    "官方视频": "官方视频",
    "发布中心": "发布中心",
    "隐私与政策": "隐私与政策",
    "发布成功": "发布成功",
    "发布成功，请在我的中进行查看": "发布成功，请在我的中进行查看",
    "查看我的发布": "查看我的发布",
    "确认订单": "确认订单",
    "置顶天数": "置顶天数",
    "置顶费用": "置顶费用",
    "总计：￥": "总计：￥",
    "提交订单": "提交订单",
    "天": "天",
    "产品经理": "产品经理",
    "立即支付": "立即支付",
    "支付剩余时间：": "支付剩余时间：",
    "选择支付方式": "选择支付方式",
    "支付结果": "支付结果",
    "支付成功，已发布": "支付成功，已发布",
    "支付方式：": "支付方式：",
    "支付时间：": "支付时间：",
    "发布论坛": "发布论坛",
    "发布分类": "发布分类",
    "标题": "标题",
    "请输入发布标题": "请输入发布标题",
    "说出你的心情": "说出你的心情",
    "发布签约作家需要平台进行审核 审核成功就发布成功。": "发布签约作家需要平台进行审核 审核成功就发布成功。",
    "选择照片": "选择照片",
    "完成": "完成",
    "请选择发布分类": "请选择发布分类",
    "您还未进行认证，请前往进行认证；": "您还未进行认证，请前往进行认证；",
    "发布入驻商家": "发布入驻商家",
    "上传logo（只能上传1张）": "上传logo（只能上传1张）",
    "上传图片": "上传图片",
    "商家分类": "商家分类",
    "商家名称": "商家名称",
    "请输入商家名称": "请输入商家名称",
    "标题": "标题",
    "请输入标题": "请输入标题",
    "请输入网址": "请输入网址",
    "请输入地址": "请输入地址",
    "详情": "详情",
    "请输入…": "请输入…",
    "可多选": "可多选",
    "我要置顶": "我要置顶",
    "是": "是",
    "否": "否",
    "支付成功，平台审核中": "支付成功，平台审核中",
    "发布入驻商家需要平台进行审核，审核成功就发布成功。审核未通过支付的置顶费用金额原路退回。": "发布入驻商家需要平台进行审核，审核成功就发布成功。审核未通过支付的置顶费用金额原路退回。",
    "接机搬家": "接机搬家",
    "清洁打扫": "清洁打扫",
    "发布折扣": "发布折扣",
    "最多上传": "最多上传",
    "张": "张",
    "内容将被丢弃，退出编辑？": "内容将被丢弃，退出编辑？",
    "继续编辑": "继续编辑",
    "发布本地生活": "发布本地生活",
    "请选择": "请选择",
    "分类": "分类",
    "顺风车": "顺风车",
    "有偿带物": "有偿带物",
    "教育": "教育",
    "运动": "运动",
    "节日": "节日",
    "休闲娱乐": "休闲娱乐",
    "宗教活动": "宗教活动",
    "请上传图片，最多上传": "请上传图片，最多上传",
    "类型": "类型",
    "求购": "求购",
    "出售": "出售",
    "价格": "价格",
    "价格：": "价格：",
    "请输入价格": "请输入价格",
    "发布租房": "发布租房",
    "区域": "区域",
    "租住类型": "租住类型",
    "房型": "房型",
    "房屋户型": "房屋户型",
    "入驻时间": "入驻时间",
    "租金": "租金",
    "请输入租金如：3000元/月": "请输入租金如：3000元/月",
    "面议": "面议",
    "房屋面积": "房屋面积",
    "请输入房屋面积": "请输入房屋面积",
    "详细地址": "详细地址",
    "请输入详细地址": "请输入详细地址",
    "租房类型": "租房类型",
    "别墅": "别墅",
    "公寓": "公寓",
    "地区": "地区",
    "安阳市": "安阳市",
    "鹤壁市": "鹤壁市",
    "济源市": "济源市",
    "焦作市": "焦作市",
    "开封市": "开封市",
    "许昌市": "许昌市",
    "郑州市": "郑州市",
    "1室": "1室",
    "0厅": "0厅",
    "0卫": "0卫",
    "2室": "2室",
    "1厅": "1厅",
    "1卫": "1卫",
    "3室": "3室",
    "2厅": "2厅",
    "2卫": "2卫",
    "4室": "4室",
    "3厅": "3厅",
    "3卫": "3卫",
    "5室": "5室",
    "4厅": "4厅",
    "选择日期": "选择日期",
    "发布二手车": "发布二手车",
    "品牌": "品牌",
    "请输入品牌": "请输入品牌",
    "车型": "车型",
    "请输入车型": "请输入车型",
    "年份": "年份",
    "付款方式(多选)": "付款方式(多选)",
    "全款": "全款",
    "分期": "分期",
    "公里数": "公里数",
    "请输入公里数": "请输入公里数",
    "发布招聘": "发布招聘",
    "招聘类型": "招聘类型",
    "请选择招聘类型": "请选择招聘类型",
    "职位名称": "职位名称",
    "请输入职位名称": "请输入职位名称",
    "薪资待遇": "薪资待遇",
    "请输入最低": "请输入最低",
    "请输入最高": "请输入最高",
    "工作地址": "工作地址",
    "请输入工作地址": "请输入工作地址",
    "全职": "全职",
    "兼职": "兼职",
    "钟点工": "钟点工",
    "发布宠物": "发布宠物",
    "宠物分类": "宠物分类",
    "宠物物品": "宠物物品",
    "宠物交友": "宠物交友",
    "我的消息": "我的消息",
    "收藏": "收藏",
    "新增关注": "新增关注",
    "平台公告": "平台公告",
    "在线客服": "在线客服",
    "好的，我知道了": "好的，我知道了",
    "客服名称": "客服名称",
    "已读": "已读",
    "未读": "未读",
    "平台消息": "平台消息",
    "消息详情": "消息详情",
    "个人主页": "个人主页",
    "我的发布": "我的发布",
    "审核中": "审核中",
    "已发布": "已发布",
    "历史记录": "历史记录",
    "我的功能": "我的功能",
    "商家认证": "商家认证",
    "签约作家": "签约作家",
    "联系我们": "联系我们",
    "意见反馈": "意见反馈",
    "设置": "设置",
    "平台认证": "平台认证",
    "通过平台认证的商家可以获得专属的金色标签并享有商家排序等级上升的专属功能。": "通过平台认证的商家可以获得专属的金色标签并享有商家排序等级上升的专属功能。",
    "在哈法App就向与平台签约的作家支付稿费签约作家也可获得专属的金色标签。": "在哈法App就向与平台签约的作家支付稿费签约作家也可获得专属的金色标签。",
    "签约作家认证": "签约作家认证",
    "请填写真实的信息，我们将会保证您的信息安全": "请填写真实的信息，我们将会保证您的信息安全",
    "姓名": "姓名",
    "请输入法人姓名": "请输入法人姓名",
    "电话号码": "电话号码",
    "请输入电话号码": "请输入电话号码",
    "邮箱号": "邮箱号",
    "请输入邮箱号": "请输入邮箱号",
    "微信号": "微信号",
    "请输入微信号": "请输入微信号",
    "证件号（护照/枫叶卡/驾照）": "证件号（护照/枫叶卡/驾照）",
    "请输入证件号": "请输入证件号",
    "请上传证件信息": "请上传证件信息",
    "证件正面": "证件正面",
    "证件反面": "证件反面",
    "认证": "认证",
    "收藏于：": "收藏于：",
    "发布中": "发布中",
    "删除成功": "删除成功",
    "编辑": "编辑",
    "年 | 公里": "年 | 公里",
    "万km": "万km",
    "该信息置顶中，确定要编辑这个信息吗？编辑发布需要重新支付置顶费用哦~": "该信息置顶中，确定要编辑这个信息吗？编辑发布需要重新支付置顶费用哦~",
    "足迹": "足迹",
    "发布于：": "发布于：",
    "审核未通过": "审核未通过",
    "请选择要删除的足迹": "请选择要删除的足迹",
    "删除": "删除",
    "地址：": "地址：",
    "是否删除该内容": "是否删除该内容",
    "报价": "报价",
    "现公里数": "现公里数",
    "标签": "标签",
    "人关注": "人关注",
    "留下你的精彩评论吧": "留下你的精彩评论吧",
    "法人姓名": "法人姓名",
    "公司名称": "公司名称",
    "请输入公司名称": "请输入公司名称",
    "详细地址": "详细地址",
    "请输入": "请输入",
    "营业执照": "营业执照",
    "技能提交成功，平台审核通过将会点亮认证图标；": "技能提交成功，平台审核通过将会点亮认证图标；",
    "返回": "返回",
    "审核失败": "审核失败",
    "重新申请": "重新申请",
    "联系客服": "联系客服",
    "放弃申请": "放弃申请",
    "我要反馈": "我要反馈",
    "反馈记录": "反馈记录",
    "反馈类型": "反馈类型",
    "反馈内容": "反馈内容",
    "问题描述的越详细，有助于我们更快的解决问题": "问题描述的越详细，有助于我们更快的解决问题",
    "我要反馈": "我要反馈",
    "反馈类型：": "反馈类型：",
    "反馈时间：": "反馈时间：",
    "平台回复：": "平台回复：",
    "我关注的人": "我关注的人",
    "确定不在关注TA吗？": "确定不在关注TA吗？",
    "不在关注": "不在关注",
    "我的粉丝": "我的粉丝",
    "官网：": "官网：",
    "微信：": "微信：",
    "公司邮箱：": "公司邮箱：",
    "公司地址：": "公司地址：",
    "呼叫客服": "呼叫客服",
    "我的资料": "我的资料",
    "头像": "头像",
    "ID": "ID",
    "昵称": "昵称",
    "性别": "性别",
    "生日": "生日",
    "职业": "职业",
    "请输入签名": "请输入签名",
    "已认证": "已认证",
    "昵称不能为空": "昵称不能为空",
    "签约合作认证": "签约合作认证",
    "保存": "保存",
    "姓名": "姓名",
    "电话号码": "电话号码",
    "邮箱号": "邮箱号",
    "证件号": "证件号",
    "修改头像": "修改头像",
    "拍照": "拍照",
    "从手机相册选择": "从手机相册选择",
    "重新选择": "重新选择",
    "选择性别": "选择性别",
    "男": "男",
    "女": "女",
    "证件号": "证件号",
    "选择生日": "选择生日",
    "账号与安全": "账号与安全",
    "注销申请提交成功": "注销申请提交成功",
    "注销理由：": "注销理由：",
    "处理中": "处理中",
    "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉": "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉",
    "关于我们": "关于我们",
    "用户注册协议": "用户注册协议",
    "隐私协议": "隐私协议",
    "清除缓存": "清除缓存",
    "检查更新": "检查更新",
    "退出登录": "退出登录",
    "修改密码": "修改密码",
    "修改绑定手机号": "修改绑定手机号",
    "通讯录黑名单": "通讯录黑名单",
    "关注和粉丝列表": "关注和粉丝列表",
    "注销账号": "注销账号",
    "移除": "移除",
    "你确认要把用户该用户移除黑名单!": "你确认要把用户该用户移除黑名!",
    "旧密码验证修改": "旧密码验证修改",
    "手机号验证修改": "手机号验证修改",
    "旧密码：": "旧密码：",
    "请输入旧密码": "请输入旧密码",
    "新密码：": "新密码：",
    "请输入新密码": "请输入新密码",
    "确认新密码：": "确认新密码：",
    "请再次输入新密码": "请再次输入新密码",
    "完 成": "完 成",
    "我们要对您绑定的手机号进行验证：": "我们要对您绑定的手机号进行验证：",
    "下一步": "下一步",
    "绑定新手机": "绑定新手机",
    "新手机号码：": "新手机号码：",
    "请输入新的手机号": "请输入新的手机号",
    "短信验证：": "短信验证：",
    "获取短信验证": "获取短信验证",
    "填写注销申请": "填写注销申请",
    "账号注销": "账号注销",
    "永久注销且无法恢复，请谨慎操作": "永久注销且无法恢复，请谨慎操作",
    "请选择注销原因": "请选择注销原因",
    "请填写注销原因": "请填写注销原因",
    "请输入~": "请输入~",
    "请输入:": "请输入:",
    "账号注销后将放弃以下权益：": "账号注销后将放弃以下权益：",
    "我已清楚风险，确定继续": "我已清楚风险，确定继续",
    "请再次确认，你已了解注销风险并要继续执行该操作": "请再次确认，你已了解注销风险并要继续执行该操作",
    "注销申请提交成功！": "注销申请提交成功！",
    "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉": "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉",
    "处理中": "处理中",
    "注销理由：": "注销理由：",
    "设置初始密码": "设置初始密码",
    "初始密码": "初始密码",
    "密码：": "密码：",
    "注册协议": "注册协议",
    "隐私政策": "隐私政策",
    "确定清理缓存？": "确定清理缓存？",
    "确定退出当前账号？": "确定退出当前账号？",
    "欢迎登录": "欢迎登录",
    "请输入密码（6-12位字母+数字）": "请输入密码（6-12位字母+数字）",
    "请输入邀请码(选填)": "请输入邀请码(选填)",
    "验证码登录": "验证码登录",
    "注册账号": "注册账号",
    "忘记密码": "忘记密码",
    "快捷登录": "快捷登录",
    "设置登录密码（6~12位数字+字母）": "设置登录密码（6~12位数字+字母）",
    "请输入邀请码（选填）": "请输入邀请码（选填）",
    "已有账号？去 登录": "已有账号？去 登录",
    "已有账号？去": "已有账号？去",
    "已有账号":"已有账号",
    "选择国家或地区": "选择国家或地区",
    "选择国家/地区：": "选择国家/地区：",
    "选择国家/地区": "选择国家/地区",
    "密码登录": "密码登录",
    "登录": "登录",
    "微信登录": "微信登录",
    "请使用微信扫描二维码登录": "请使用微信扫描二维码登录",
    "绑定手机号": "绑定手机号",
    "确认登录密码(6~12位数字+字母)": "确认登录密码(6~12位数字+字母)",
    "电话：": "电话：",
    "微信号：": "微信号：",
    "马上登录": "马上登录",
    "更新日期": "更新日期",
    "请输入想要搜索信息": "请输入想要搜索信息",
    "扫码下载APP": "扫码下载APP",
    "IOS": "IOS",
    "小程序": "小程序",
    "在线咨询": "在线咨询",
    "热线电话：": "热线电话：",
    "Hi，您还没有进行登录请前往进行登录": "Hi，您还没有进行登录请前往进行登录",
    "已选条件": "已选条件",
    "分类：": "分类：",
    "清除筛选": "清除筛选",
    "更多": "更多",
    "共": "共",
    "每页": "每页",
    "前往": "前往",
    "页": "页",
    "举报内容": "举报内容",
    "请填写举报理由": "请填写举报理由",
    "我的关注": "我的关注",
    "私信": "私信",
    "分享": "分享",
    "全部评论": "全部评论",
    "收起回复": "收起回复",
    "回复愤怒的小鸟:": "回复愤怒的小鸟:",
    "发表": "发表",
    "已收藏": "已收藏",
    "审核未通过支付的置顶费用金额原路退回。": "审核未通过支付的置顶费用金额原路退回。",
    "发布入驻商家需要平台进行审核，审核成功就发布成功。": "发布入驻商家需要平台进行审核，审核成功就发布成功。",
    "论坛列表": "论坛列表",
    "论坛详情": "论坛详情",
    "商家名称：": "商家名称：",
    "网址：": "网址：",
    "租住：": "租住：",
    "地区：": "地区：",
    "用户昵称": "用户昵称",
    "付款方式：": "付款方式：",
    "工作地址：": "工作地址：",
    "订单金额：¥": "订单金额：¥",
    "确定删除该条评论；": "确定删除该条评论；",
    "选择类型": "选择类型",
    "填写内容": "填写内容",
    "发布-今日折扣": "发布-今日折扣",
    "结算": "结算",
    "置顶": "置顶",
    "置顶信息": "置顶信息",
    "小计": "小计",
    "总额：": "总额：",
    "应付总额：": "应付总额：",
    "发布-租房": "发布-租房",
    "发布-宠物": "发布-宠物",
    "发布-招聘": "发布-招聘",
    "发布-二手车": "发布-二手车",
    "发布-二手交易": "发布-二手交易",
    "发布-本地生活": "发布-本地生活",
    "收银台": "收银台",
    "订单提交成功，请尽快付款！": "订单提交成功，请尽快付款！",
    "订单号：": "订单号：",
    "请您在": "请您在",
    "订单提交成功，请尽快付款！订单号：": "订单提交成功，请尽快付款！订单号：",
    "内完成支付，否则订单会被自动取消": "内完成支付，否则订单会被自动取消",
    "应付金额": "应付金额",
    "打开手机  微信扫一扫继续付款": "打开手机  微信扫一扫继续付款",
    "订单金额：": "订单金额：",
    "发布分类：": "发布分类：",
    "标题：": "标题：",
    "图片：": "图片：",
    "点击上传": "点击上传",
    "打开手机 微信扫一扫继续付款": "打开手机 微信扫一扫继续付款",
    "详情：": "详情：",
    "富文本框；有图有文字": "富文本框；有图有文字",
    "秒": "秒",
    "分": "分",
    "时": "时",
    "天": "天",
    "论坛发布": "论坛发布",
    "微信支付": "微信支付",
    "支付宝": "支付宝",
    "支付方式": "支付方式",
    "发布签约作家需要平台进行审核 审核成功就发布成功。": "发布签约作家需要平台进行审核 审核成功就发布成功。",
    "审核成功就发布成功。": "审核成功就发布成功。",
    "发布签约作家需要平台进行审核": "发布签约作家需要平台进行审核",
    "您还未进行认证，请前往认证；": "您还未进行认证，请前往认证；",
    "上传图片（最多9张）：": "上传图片（最多9张）：",
    "商家分类：": "商家分类：",
    "商家名称：": "商家名称：",
    "请输入详情": "请输入详情",
    "标签（可多选）：": "标签（可多选）：",
    "我要置顶：": "我要置顶：",
    "发布-入驻商家": "发布-入驻商家",
    "分类：": "分类：",
    "区域：": "区域：",
    "请选择区域": "请选择区域",
    "租住类型：": "租住类型：",
    "房型：": "房型：",
    "房屋户型：": "房屋户型：",
    "请选择几室": "请选择几室",
    "请选择几厅": "请选择几厅",
    "请选择几卫": "请选择几卫",
    "入驻时间：": "入驻时间：",
    "请选择入驻时间": "请选择入驻时间",
    "请输入租金如:$3000/月": "请输入租金如:$3000/月",
    "租金：": "租金：",
    "房屋面积：": "房屋面积：",
    "详细地址：": "详细地址：",
    "品牌：": "品牌：",
    "车型：": "车型：",
    "年份：": "年份：",
    "请选择年份": "请选择年份",
    "付款方式（多选）：": "付款方式（多选）：",
    "公里数：": "公里数：",
    "招聘类型：": "招聘类型：",
    "职位名称：": "职位名称：",
    "薪资待遇：": "薪资待遇：",
    "请输入薪资待遇": "请输入薪资待遇",
    "用户中心": "用户中心",
    "个人资料": "个人资料",
    "请输入昵称": "请输入昵称",
    "请输入ID": "请输入ID",
    "账户密码": "账户密码",
    "关注/粉丝": "关注/粉丝",
    "黑名单": "黑名单",
    "通过平台认证的商家可以获得专属的金色标签 并享有商家排序等级上升的专属功能。": "通过平台认证的商家可以获得专属的金色标签 并享有商家排序等级上升的专属功能。",
    "在哈法App就向与平台签约的作家支付稿费 签约作家也可获得专属的金色标签。": "在哈法App就向与平台签约的作家支付稿费 签约作家也可获得专属的金色标签。",
    "我的私信": "我的私信",
    "查看全部私信": "查看全部私信",
    "通知": "通知",
    "查看全部通知": "查看全部通知",
    "查看全部收藏": "查看全部收藏",
    "开始关注了你": "开始关注了你",
    "通知中心": "通知中心",
    "收藏了你的": "收藏了你的",
    "回复了您：": "回复了您：",
    "头像：": "头像：",
    "信息": "信息",
    "操作": "操作",
    "+ 关注": "+ 关注",
    "该信息置顶中，确定要编辑这个信息吗？编辑发布需要 重新支付置顶费用哦~": "该信息置顶中，确定要编辑这个信息吗？编辑发布需要 重新支付置顶费用哦~",
    "您的意见是我们前进的动力": "您的意见是我们前进的动力",
    "请输入您的意见或反馈": "请输入您的意见或反馈",
    "昵称：": "昵称：",
    "ID：": "ID：",
    "性别：": "性别：",
    "生日：": "生日：",
    "签名：": "签名：",
    "未认证": "未认证",
    "商家认证：": "商家认证：",
    "签约作家：": "签约作家：",
    "法人姓名：": "法人姓名：",
    "电话号码：": "电话号码：",
    "证件号（护照/枫叶卡/驾照）：": "证件号（护照/枫叶卡/驾照）：",
    "公司名称：": "公司名称：",
    "请上传公司相关信息": "请上传公司相关信息",
    "证件正面：": "证件正面：",
    "营业执照：": "营业执照：",
    "邮箱号：": "邮箱号：",
    "法人姓名：": "法人姓名：",
    "电话号码：": "电话号码：",
    "证件号（护照/枫叶卡/驾照）：": "证件号（护照/枫叶卡/驾照）：",
    "请输入证件号（护照/枫叶卡/驾照）": "请输入证件号（护照/枫叶卡/驾照）",
    "公司名称：": "公司名称：",
    "公司营业执照需加盖公章上传，否则审核不通过": "公司营业执照需加盖公章上传，否则审核不通过",
    "证件反面：": "证件反面：",
    "提交认证": "提交认证",
    "技能提交成功，平台审核通过将会点亮技能图标；": "技能提交成功，平台审核通过将会点亮技能图标；",
    "姓名：": "姓名：",
    "请输入姓名": "请输入姓名",
    "邮箱号：": "邮箱号：",
    "微信号：": "微信号：",
    "账号密码": "账号密码",
    "提交成功": "提交成功",
    "填写注销消息":"填写注销消息",
    "换一个":"换一个",
    "短信验证":"短信验证",
    "获取验证码:":"获取验证码:",
    "短信验证码:":"短信验证码:",
    "s后重新获取:":"s后重新获取:",
    "图形验证码:":"图形验证码:",
    "更换新手机号":"更换新手机号",
    "发送内容不能为空!":"发送内容不能为空!",
    "当前手机号码:":"当前手机号码:",
    "绑定手机：您已绑定手机：": "绑定手机：您已绑定手机：",
    "，若手机丢失或停用，请及时更换": "，若手机丢失或停用，请及时更换",
    "修改": "修改",
    "登录密码：联网帐号存在被盗风险，定期更改密码已保护帐户安全": "登录密码：联网帐号存在被盗风险，定期更改密码已保护帐户安全",
    "注销账号：注销账号所有信息将被删除，账号不能进行登录": "注销账号：注销账号所有信息将被删除，账号不能进行登录",
    "关注和粉丝列表：隐私设置关闭别人将不能查看关注和粉丝列表": "关注和粉丝列表：隐私设置关闭别人将不能查看关注和粉丝列表",
    "可见": "可见",
    "填写注销信息": "填写注销信息",
    "请填写注销账号理由": "请填写注销账号理由",
    "请输入": "请输入",
    "1、账号信息、第三方授权信息将被清空且无法恢复。": "1、账号信息、第三方授权信息将被清空且无法恢复。",
    "2、账号相关信息将会一并被删除且无法恢复。": "2、账号相关信息将会一并被删除且无法恢复。",
    "3、注销后手机号码可重新注册，所生成账号为全新的账号，不包含注销账号的任何信息。": "3、注销后手机号码可重新注册，所生成账号为全新的账号，不包含注销账号的任何信息。",
    "账号注销后将放弃以下权益原因：": "账号注销后将放弃以下权益原因：",
    "点击下方按钮，即表示你已阅读并了解以上风险": "点击下方按钮，即表示你已阅读并了解以上风险",
    "请再次确认，你已了解注销风险，并要继续执行该操作": "请再次确认，你已了解注销风险，并要继续执行该操作",
    "更换新手机号": "更换新手机号",
    "我已清除风险，确定继续": "我已清除风险，确定继续",
    "当前手机号码：": "当前手机号码：",
    "图形验证码：": "图形验证码：",
    "换张图": "换张图",
    "短信验证码：": "短信验证码：",
    "温馨提醒": "温馨提醒",
    "你主动注销后，我们将停止为你提供产品/服务，根据适用法律的要求删除你的个人信息，或使其匿名化处理": "你主动注销后，我们将停止为你提供产品/服务，根据适用法律的要求删除你的个人信息，或使其匿名化处理",
    "填写并提交注销申请，工作人员会协助你完成注销。": "填写并提交注销申请，工作人员会协助你完成注销。",
    "若有疑问请联系在线客服或拨打": "若有疑问请联系在线客服或拨打",
    "为保障您的帐号安全，变更重要信息需要短信验证": "为保障您的帐号安全，变更重要信息需要短信验证",
    "若有疑问请联系在线客服或拨打400-000-0000": "若有疑问请联系在线客服或拨打400-000-0000",
    "修改登录密码": "修改登录密码",
    "当前手机号码：": "当前手机号码：",
    "验证码：": "验证码：",
    "设置密码：": "设置密码：",
    "请输入密码": "请输入密码",
    "请确认登录密码": "请确认登录密码",
    "密码输入不一致": "密码输入不一致",
    "确认密码：": "确认密码：",
    "请再次输入密码": "请再次输入密码",
    "请再次输入密码!": "请再次输入密码!",
    "请输入确认密码": "请输入确认密码",
    "设置完成": "设置完成",
    "初始密码": "初始密码",
    "选择语言": "选择语言",
    "请输入用户名":"请输入用户名",
    "请先登录":"请先登录",
    "一卡通":"一卡通",
    "/月":"/月",
    "请选择发布分类":"请选择发布分类",
    "入住时间":"入住时间",
    "入住时间：":"入住时间：",
    "暂无":"暂无",
    "公里":"公里",
    "请输入手机号/ID号":"请输入手机号/ID号",
    "手机号/ID号只能是数字":"手机号/ID号只能是数字",
    "请输入评论":"请输入评论",
    "没有筛选项":"没有筛选项",
    "请选择举报类型":"请选择举报类型",
    "请输入6-12位密码":"请输入6-12位密码",
    "验证码不能为空":"验证码不能为空",
    "请安装微信后再使用此功能":"请安装微信后再使用此功能",
    "由于该用户隐私设置，粉丝列表不可见":"由于该用户隐私设置，粉丝列表不可见",
    "密码格式错误":"密码格式错误",
    "账号格式错误":"账号格式错误",
    "验证码格式错误":"验证码格式错误",
    "请勾选用户协议":"请勾选用户协议",
    "手机号不能为空":"手机号不能为空",
    "手机号格式错误":"手机号格式错误",
    "密码不能为空":"密码不能为空",
    "请输入验证码":"请输入验证码",
    "请输入密码":"请输入密码",
    "请上传图片":"请上传图片",
    "图片":"图片",
    "不吸烟":"不吸烟",
    "独立屋":"独立屋",
    "请填写标题":"请填写标题",
    "请填写详情":"请填写详情",
    "请选择分类":"请选择分类",
    "请选择招聘分类":"请选择招聘分类",
    "请填写职位名称":"请填写职位名称",
    "请选择新职待遇":"请选择新职待遇",
    "请选择区域":"请选择区域",
    "请填写内容":"请填写内容",
    "请选择房型":"请选择房型",
    "室": "室",
    "卫": "卫",
    "厅": "厅",
    "类型：": "类型：",
    "请选择房屋户型":"请选择房屋户型",
    "请选择入驻时间":"请选择入驻时间",
    "请选择付款类型":"请选择付款类型",
    "请选择租住类型":"请选择租住类型",
    "请选择商家分类":"请选择商家分类",
    "请填写商家名称":"请填写商家名称",
    "请填写品牌":"请填写品牌",
    "请填写车型":"请填写车型",
    "请选择年份":"请选择年份",
    "请选择付款方式":"请选择付款方式",
    "请选择价格方式":"请选择价格方式",
    "请填写公里数":"请填写公里数",
    "请选择交易类型":"请选择交易类型",
    "上传logo（只能上传1张）：":"上传logo（只能上传1张）：",
    "请选择标签":"请选择标签",
    "请填写姓名":"请填写姓名",
    "请填写手机号":"请填写手机号",
    "请填写正确的邮箱":"请填写正确的邮箱",
    "请填写微信号":"请填写微信号",
    "请输入证件号":"请输入证件号",
    "请上传身份证正面":"请上传身份证正面",
    "请上传身份证反面":"请上传身份证反面",
    "请选择反馈类型":"请选择反馈类型",
    "请填写反馈内容":"请填写反馈内容",
    "反馈成功":"反馈成功",
    "请填写法人姓名":"请填写法人姓名",
    "手机号输入有误":"手机号输入有误",
    "请填写电话号码":"请填写电话号码",
    "请填写证件号":"请填写证件号",
    "请上传证件反面":"请上传证件反面",
    "请上传证件正面":"请上传证件正面",
    "请填写公司名称":"请填写公司名称",
    "请填写详细地址":"请填写详细地址",
    "请上传营业执照":"请上传营业执照",
    "请选择注销原因":"请选择注销原因",
    "两次输入密码不一致":"两次输入密码不一致",
    "两次输入密码不一致!":"两次输入密码不一致!",
    "手机号格式不正确":"手机号格式不正确",
    "两次输入的密码不一致":"两次输入的密码不一致",
    "旧密码格式错误":"旧密码格式错误",
    "论坛":"论坛",


    
    "用户名不能为空":"用户名不能为空",
    "用户名1-20位":"用户名1-20位",
    "密码不能为空":"密码不能为空",
    "密码1-20位":"密码1-20位",
    "最新视频":"最新视频",
    "平台审核通过将会点亮技能图标":"平台审核通过将会点亮技能图标",
    "刷新":"刷新",
    "顶部":"顶部",
    "请输入内容":"请输入内容",
    "客服":"客服",
    "最新":"最新",
    "吐槽":"吐槽",
    "官方视频":"官方视频",
    "生活":"生活",
    "签约作家":"签约作家",
    "招聘类型：":"招聘类型：",
    "发布时间：":"发布时间：",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",
    "用户名不能为空":"用户名不能为空",

}
export default zh


// WEBPACK FOOTER //
// ./src/i18n/langs/zh-CN.js